import { config } from '../../config';

export async function sendRideId(id) {
    try {
        // console.log(id);

        // API to send the data to the backend
        const response = await fetch(`${config.API_BASE_URL}/api/login7/complete`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ id: id })
        });

        // Check for HTTP errors (e.g., 404, 500) before parsing JSON
        if (!response.ok) {
            // console.error("HTTP Error:", response.status, response.statusText);
            alert(`HTTP Error: ${response.status} ${response.statusText}`);
            return false; // Return false on network/HTTP error
        }

        const result = await response.json();

        if (result.status === "success") {
            // console.log("Success:", result);
            return true; // Return true on success
        } else {
            // Backend returned a fail status
            // console.log("Backend failed:", result);
            // alert(`Failed: ${result.message || "Unknown error"}`);
            alert("Failed: Unknown error");
            return false; // Return false on backend status fail
        }

    } catch (error) {
        // console.error("Error sending data:", error);
        alert("An unexpected error occurred during the request.");
        return false; // Return false on any caught exception (network, JSON parsing, etc.)
    }
}